import { render, staticRenderFns } from "./DirectList.vue?vue&type=template&id=5df131da&scoped=true&"
import script from "./DirectList.vue?vue&type=script&lang=js&"
export * from "./DirectList.vue?vue&type=script&lang=js&"
import style0 from "./DirectList.vue?vue&type=style&index=0&id=5df131da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df131da",
  null
  
)

export default component.exports